import React from "react";
import "./About.css";
import photoOne from '../../../assets/images/photo2.jpg'
import photoTwo from '../../../assets/images/photo4.jpg'

const About = () =>{
    return(
        <section className="section-about wrapper">
            <div className="about-conteiner">
                <div className="about-element">
                    <div className="about-photo">
                        <img src={photoOne} alt="zdjęcie przedstawiające park linowy" />
                    </div>
                    <div className="about-text m-l"> 
                        <h3>O parku</h3>
                        <p>Park linowy Ośrodka Sportu i Rekreacji w Lubawie znajduje się na terenie Parku Miejskiego Łazienki Lubawskie. Do dyspozycji odwiedzających oddajemy łącznie ponad pół kilometra czystych emocji! Trasy wiodą wyłącznie po drzewach, wśród ptaków i naturalnej zieleni. Popisom odwiedzających przyglądają się kaczki, czarne łabędzie i kolorowe karasie.</p>
                    </div>
                </div>
                <div className="about-element">
                    <div className="about-photo second-element">
                    <img src={photoTwo} alt="zdjęcie przedstawiające park linowy" />
                    </div>
                    <div className="about-text m-r"> 
                        <h3>Kto może skorzystać ?</h3>
                        <p>Przede wszystkim – trzeba chcieć przeżyć wspaniałą przygodę. Żeby skorzystać z atrakcji parku linowego, trzeba liczyć powyżej 120 cm wzrostu. Możemy wtedy skorzystać z trasy dziecięcej. Osoby, które mierzą powyżej 160 cm. mogą skorzystać z trasy standard i trasy tyrolkowej.</p>
                    </div>
                </div>
            </div>
            
        </section>
    )
}


export default About;